module.exports = __webpack_public_path__ + "img/wavePickingS1Page.9bc4da3b.png";